import {
  INIT_SESSION,
  SET_ATTEMPTED_ROUTE,
  SET_LEARNING_LINK,
  SET_LOCALE,
  SET_OWNER_RETAILER_GROUPS,
  SET_RETAILER_GROUPS,
  SET_SIDE_MENU,
  SET_TOKENS,
  SET_TOP_MENU,
  SET_USER_PRIVILEGES,
  UPDATE_SESSION,
  TOGGLE_SUBMENU,
  CLOSE_ALL_SIDEMENU_ITEMS,
  SET_PAGE_TITLE,
} from '../actions/session.actions';

export const initialState = {
  tokens: {},
  rest: [],
  role: null,
  oAuthClientId: null,
  siteId: null,
  loggedIn: false,
  retailer: {},
  passwordReset: false,
  jurisdiction: null,
  privileges: [],
  locale: 'en_US',
  sidemenu: [],
  topmenu: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE_TITLE:
      return { ...state, pageTitle: action.payload.pageTitle };
    case SET_LOCALE:
      return { ...state, locale: action.payload.locale };
    case INIT_SESSION:
      return { ...state, ...action.payload };
    case UPDATE_SESSION:
      return { ...state, ...action.payload };
    case SET_SIDE_MENU:
      return { ...state, sidemenu: action.payload };
    case SET_TOP_MENU:
      return { ...state, topmenu: action.payload };
    case SET_TOKENS:
      return { ...state, tokens: action.payload };
    case SET_USER_PRIVILEGES:
      return { ...state, privileges: action.payload };
    case SET_LEARNING_LINK:
      return { ...state, lotteryLearningLink: action.payload };
    case SET_ATTEMPTED_ROUTE:
      return { ...state, attemptedRoute: action.payload };
    case SET_RETAILER_GROUPS:
      return { ...state, retailerGroups: action.payload };
    case SET_OWNER_RETAILER_GROUPS:
      return { ...state, ownerRetailerGroups: action.payload };
    case CLOSE_ALL_SIDEMENU_ITEMS:
      return {
        ...state,
        sidemenu: state.sidemenu.map((item) => {
          if (item.opened) {
            return {
              ...item,
              opened: false,
            };
          }

          return item;
        }),
      };
    case TOGGLE_SUBMENU:
      return {
        ...state,
        sidemenu: state.sidemenu.map((item) => {
          if (item.id === action.id) {
            return {
              ...item,
              opened: !item.opened,
            };
          }

          return {
            ...item,
            opened: false,
          };
        }),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/auth/reducers/session.reducer.js